import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

function Redirect() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const utmSource = searchParams.get('utm_source');
    const utmMedium = searchParams.get('utm_medium');
    const utmCampaign = searchParams.get('utm_campaign');

    // Check if this is the botzilla campaign from LinkedIn
    if (utmSource === 'linkedin' && utmMedium === 'social' && utmCampaign === 'botzilla') {
      // Redirect to external botzilla.ch with transformed UTM parameters
      window.location.href = 'https://botzilla.ch/';
    } else {
      // Default redirect to botzilla.ch preserving original parameters
      const params = searchParams.toString();
      window.location.href = params ? `https://botzilla.ch/?${params}` : 'https://botzilla.ch/';
    }
  }, [searchParams]);

  return null;
}

export default Redirect;
